<template>
  <div>
    <v-form
      ref="form"
      v-model="valid"
      @keyup.enter.native="reauthenticate"
    >
      <v-card elevation="0">
        <v-card-text>
          <v-text-field
            v-model="password"
            :disabled="saving"
            :rules="[validateRequired, ...passwordRules]"
            label="Password"
            type="password"
            required
            @blur="passwordDirty = true"
          />
        </v-card-text>
        <v-card-actions>
          <v-btn
            :to="{ name: 'password-reset' }"
            large
            text
          >
            Trouble re-authenticating?
          </v-btn>
          <v-spacer />
          <v-btn
            :disabled="!canSubmit"
            :loading="saving"
            color="primary"
            large
            @click.stop="reauthenticate"
          >
            Re-authenticate
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </div>
</template>

<script>
import { auth } from '@/firebase'
import { EmailAuthProvider } from 'firebase/auth'
import { AUTH_WRONG_PASSWORD } from '@/utils/auth'
import { validateRequired } from '@/utils/validationRules'

export default {
  name: 'Auth',
  emits: ['reauthenticate'],
  data: function () {
    return {
      valid: false,
      password: null,
      passwordDirty: false,
      saving: false
    }
  },
  computed: {
    passwordRules() {
      var rules = []
      if (this.passwordDirty && !this.password) {
        rules.push('Please enter your password')
      } else {
        rules.push(true)
      }
      return rules
    },
    canSubmit() {
      return this.valid && !this.saving
    }
  },
  methods: {
    validateRequired,
    async reauthenticate() {
      if (!this.canSubmit) {
        return
      }
      try {
        this.saving = true
        await auth.currentUser.reauthenticateWithCredential(
          EmailAuthProvider.credential(auth.currentUser.email, this.password)
        )
        await this.$store.dispatch('reloadCurrentUser')
        this.$emit('reauthenticate')
      } catch (error) {
        if (AUTH_WRONG_PASSWORD === error.code) {
          this.$showErrorbar('Your password is incorrect.')
        } else {
          this.$showErrorbar(
            'Unable to re-authenticate. Please contact support.'
          )
          throw error
        }
      } finally {
        this.saving = false
      }
    }
  }
}
</script>

<style lang="scss"></style>
